import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ValidityModel } from './validity.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class ValidityService {
  constructor(private http: HttpClient) {}

  addValidity(validity: ValidityModel) {
    
    return this.http.post(API_URL + '/Validity/CreateValidity', validity, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateValidity(validity: ValidityModel) {
    
    return this.http.put(API_URL + '/Validity/UpdateValidity', validity, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllValidities(): Observable<ValidityModel[]> {
    return this.http.get(API_URL + '/Validity/ReadValidities', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deleteValidity(validity: ValidityModel) {
    
    return this.http
      .delete(API_URL + '/Validity/DeleteValidity', {
        headers: {},
        body: validity,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
